"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Icon } from "@/components/formatters/MXPIcon";
import { useScreenSize } from "../../utils/hooks/useScreenSize";
interface DropdownProps {
  options: {
    label: string;
    value: string;
  }[] | string[];
  selectedFilters?: string[];
  onChange: (selectedOptions: string[]) => void;
  label?: string;
  multiSelect?: boolean;
  displayResetAll?: boolean;
  resetAllLabel?: string;
  onResetAll?: () => void;
  inputClasses?: string;
  wrapperClasses?: string;
  dropdownClasses?: string;
}
const CHECKBOX_BASE = "min-w-[18px] min-h-[18px] cursor-pointer ml-auto appearance-none rounded border border-gray-m10 bg-transparent pointer-events-none";
const CHECKMARK_SVG = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8l3 3 5-6'/%3E%3C/svg%3E\")";
const checkedStyle: React.CSSProperties = {
  backgroundColor: "#0063A3",
  borderColor: "#0063A3",
  backgroundImage: CHECKMARK_SVG,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "70%"
};
export const Dropdown = t0 => {
  const $ = _c(42);
  const {
    options,
    onChange,
    label,
    selectedFilters: t1,
    multiSelect: t2,
    displayResetAll,
    resetAllLabel,
    onResetAll,
    inputClasses,
    wrapperClasses,
    dropdownClasses
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const selectedFilters = t3;
  const multiSelect = t2 === undefined ? true : t2;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(selectedFilters);
  useScreenSize();
  let t4;
  let t5;
  if ($[2] !== selectedFilters) {
    t4 = () => {
      setSelectedOptions(selectedFilters || []);
    };
    t5 = [selectedFilters];
    $[2] = selectedFilters;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== multiSelect || $[6] !== onChange || $[7] !== selectedOptions) {
    t6 = option => {
      let updatedSelectedOptions;
      if (multiSelect) {
        if (selectedOptions.includes(option)) {
          updatedSelectedOptions = selectedOptions.filter(o => o !== option);
        } else {
          updatedSelectedOptions = [...selectedOptions, option];
        }
      } else {
        updatedSelectedOptions = [option];
      }
      setSelectedOptions(updatedSelectedOptions);
      onChange(updatedSelectedOptions);
    };
    $[5] = multiSelect;
    $[6] = onChange;
    $[7] = selectedOptions;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleOptionClick = t6;
  const preventOptionBlur = _temp;
  let t7;
  if ($[9] !== onChange) {
    t7 = () => {
      setSelectedOptions([]);
      onChange([]);
    };
    $[9] = onChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleClearAll = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_0 => {
      if (!e_0.currentTarget.contains(e_0.relatedTarget)) {
        setIsOpen(false);
      }
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleBlur = t8;
  const t9 = `relative text-left rounded-lg min-w-[185px] w-fit outline-none bg-white border border-gray-m2 shadow-sm max-lg:w-full max-lg:shadow-md ${isOpen ? "shadow-md" : ""} ${wrapperClasses} `;
  const t10 = `flex gap-5 items-center py-[10px] px-4 rounded-lg cursor-pointer max-lg:justify-between ${inputClasses}`;
  let t11;
  if ($[12] !== isOpen) {
    t11 = () => setIsOpen(!isOpen);
    $[12] = isOpen;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon type="t2u-chevron-right" rotateDeg="90" size={12} />;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== label || $[16] !== t10 || $[17] !== t11) {
    t13 = <div className={t10} onClick={t11} tabIndex={0} data-testid="dropdown-trigger">{label}{t12}</div>;
    $[15] = label;
    $[16] = t10;
    $[17] = t11;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = `mt-[6px] absolute bg-white z-10 w-full max-h-[300px] overflow-hidden flex flex-col rounded-lg shadow-md transition-all ${isOpen ? "visible opacity-100" : "invisible opacity-0 pointer-events-none"} ${dropdownClasses}`;
  let t15;
  if ($[19] !== handleOptionClick || $[20] !== options || $[21] !== selectedOptions) {
    let t16;
    if ($[23] !== handleOptionClick || $[24] !== selectedOptions) {
      t16 = (option_0, index) => {
        const value = typeof option_0 === "string" ? option_0 : option_0.value;
        const label_0 = typeof option_0 === "string" ? option_0 : option_0.label;
        return <li key={`option-${value}-${index}`} className="cursor-pointer py-[10px] px-4 flex items-center justify-between list-none text-gray-m7 text-base font-normal leading-6 tracking-normal hover:bg-gray-m1" onMouseDown={preventOptionBlur} onClick={() => handleOptionClick(value)}><span className={selectedOptions.includes(value) ? "text-blue-trmb font-semibold" : ""}>{label_0}</span><input type="checkbox" className={CHECKBOX_BASE} style={selectedOptions.includes(value) ? checkedStyle : undefined} checked={selectedOptions.includes(value)} onChange={() => handleOptionClick(value)} /></li>;
      };
      $[23] = handleOptionClick;
      $[24] = selectedOptions;
      $[25] = t16;
    } else {
      t16 = $[25];
    }
    t15 = options.map(t16);
    $[19] = handleOptionClick;
    $[20] = options;
    $[21] = selectedOptions;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[26] !== t15) {
    t16 = <ul className="list-none m-0 p-0 flex-1 overflow-y-auto flex flex-col max-sm:w-full">{t15}</ul>;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== displayResetAll || $[29] !== handleClearAll || $[30] !== multiSelect || $[31] !== onResetAll || $[32] !== resetAllLabel) {
    t17 = multiSelect && !displayResetAll ? <div className="flex justify-between p-2 bg-white border-t border-gray-m2"><button className="border-none cursor-pointer text-sm font-bold leading-normal tracking-wide rounded uppercase bg-transparent text-gray-m3" onClick={handleClearAll}>Clear All</button></div> : onResetAll ? <div className="flex justify-between p-2 bg-white border-t border-gray-m2"><button className="border-none cursor-pointer text-sm font-bold leading-normal tracking-wide rounded uppercase bg-transparent text-gray-m3" onClick={onResetAll}>{resetAllLabel || "Reset All"}</button></div> : null;
    $[28] = displayResetAll;
    $[29] = handleClearAll;
    $[30] = multiSelect;
    $[31] = onResetAll;
    $[32] = resetAllLabel;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t14 || $[35] !== t16 || $[36] !== t17) {
    t18 = <div data-testid="dropdown-options" className={t14}>{t16}{t17}</div>;
    $[34] = t14;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t13 || $[39] !== t18 || $[40] !== t9) {
    t19 = <div className={t9} tabIndex={0} onBlur={handleBlur}>{t13}{t18}</div>;
    $[38] = t13;
    $[39] = t18;
    $[40] = t9;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
};
function _temp(e) {
  e.preventDefault();
}